import { Role } from '@src/main/modules/roles/domain/role.interface';
import { RoleRepository } from '@src/main/modules/roles/domain/role.repository';

export const findAllRoles = async (repository: RoleRepository): Promise<Role[]> =>
  await repository.findAll();
